import { styled } from 'styled-components'

export const Description = styled.div`
  max-width: 232px;
`
